import type { Cliente } from '../db/tipos'
import { ROTULO_MOTIVO_INATIVACAO } from '../clientes/inativacao'
import { formatarData } from '../lib/formatos'

// UM componente para os TRES lugares (ficha do cliente, pedido aberto, fechar
// pedido). Tres tarjas parecidas divergem com o tempo -- uma perde a data,
// outra perde o motivo -- e o representante passa a ler versoes diferentes do
// mesmo fato. A forma mais forte de copiar strings e nao copiar nada.
//
// Olha o STATUS, e nunca o motivo: reativar preserva motivo, observacao e data
// de proposito (historico), entao um aviso guiado pelo motivo acusaria de
// inativo todo cliente ja reativado.
export default function AvisoClienteInativo({
  cliente,
  temPedido = false,
}: {
  cliente: Cliente
  temPedido?: boolean
}) {
  if (cliente.status !== 'inativo') return null

  const motivo = cliente.motivo_inativacao
    ? ROTULO_MOTIVO_INATIVACAO[cliente.motivo_inativacao]
    : null
  const quando = cliente.inativado_em ? formatarData(new Date(cliente.inativado_em)) : null

  return (
    <div className="bg-red-50 border border-red-300 text-red-800 rounded-xl p-3 text-sm space-y-0.5">
      <p className="font-medium">
        🚫 Cliente inativado{quando ? ` em ${quando}` : ''}
      </p>
      {motivo && (
        <p>
          Motivo: {motivo}
          {cliente.obs_inativacao ? ` — "${cliente.obs_inativacao}"` : ''}
        </p>
      )}
      {temPedido && <p>Você ainda pode concluir este pedido.</p>}
    </div>
  )
}
